import React, { useEffect, useState } from "react";
import axios from "axios";
import { AppSingleSelect, AppRemixIcon } from "@/layout/AppComponents";
import ReactDOMServer from "react-dom/server";
import BtnOptions from "./BtnOptions";
import Translator from "../../../../components/helpers/Translator";
import UserSelectStates from "../../../../components/form/Selects/UserSelectStates";
import useIsMounted from "../../../../../layout/components/hooks/useIsMounted";
import { axiosPath } from "../../../../../routing/helpers/router";

export default function Report47Options({
  handleOnSetFieldValue,
  handleOnSubmit,
  handleOnSave,
  values,
  selectedReport,
}) {
  const isMounted = useIsMounted();
  const [reportOptions, setReportOptions] = useState();
  const [loading, setLoading] = useState(true);
  const translations = {
    mode0: ReactDOMServer.renderToString(<Translator
      file="module-intelligence"
      name="module.int.mode-selected"
    />),
    mode1: ReactDOMServer.renderToString(<Translator
      file="module-intelligence"
      name="module.int.mode-plants"
    />),
  };
  const [noYesOptions] = useState([
    {
      label: ReactDOMServer.renderToString(<Translator file="user" name="general.no" />),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(<Translator file="user" name="general.yes" />),
      value: 1,
    },
  ]);

  useEffect(() => {
    handleOnSetFieldValue("mode", { value: 0, label: translations.mode0 });
  }, []);

  // > LOAD REPORT OPTIONS //
  useEffect(() => {
    if (
      (values.plants && values.plants.length > 0) ||
      (values.plantGroups && values.plantGroups.length > 0)
    ) {
      setLoading(true);
      setReportOptions(undefined);
      axios
        .post(axiosPath("api_r_user_module_intelligence_getReportOptions"), {
          report: 47,
          selectedReport,
          payload: values,
        })
        .then(({ data }) => {
          if (isMounted.current) {
            setReportOptions(data);
            setLoading(false);
          }
        })
        .catch(() => "");
    }
  }, []);
  // < LOAD REPORT OPTIONS //

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <UserSelectStates
            onHandleChange={(opt) => {
              handleOnSetFieldValue("states", opt);
            }}
            value={values?.states}
            getPermissionsFrom="client"
            hasSelectOptions
            hideObsolete
          />
        </div>
      </div>
      {values.plantGroups && (
        <div className="row">
          <div className="col-lg-12">
            <AppSingleSelect
              icon={<AppRemixIcon icon="shuffle" />}
              options={[
                { value: 0, label: translations.mode0 },
                { value: 1, label: translations.mode1 },
              ]}
              title={ReactDOMServer.renderToString(
                <Translator file="module-intelligence" name="module.int.mode" />
              )}
              placeholder={
                <Translator file="export" name="export.excel.select.text" />
              }
              value={values.mode}
              onChange={(opt) => handleOnSetFieldValue("mode", opt)}
            />
          </div>
        </div>
      )}
      {reportOptions?.plantObligationTags && (
        <div className="row">
          <div className="col-lg-12">
            <h6>Etiquetas de obligaciones</h6>
            <div className="mb-5">
              {reportOptions?.plantObligationTags?.map((ot) => (
                <React.Fragment key={ot.id}>
                  <AppSingleSelect
                    title={ot?.name}
                    options={noYesOptions}
                    icon={<AppRemixIcon icon="price-tag-3" />}
                    onChange={(value) =>
                      handleOnSetFieldValue(
                        `plantObligationTags[${ot.id}]`,
                        value
                      )
                    }
                    value={values?.plantObligationTags?.[ot.id]}
                    placeholder={ReactDOMServer.renderToString(
                      <Translator file="general" name="general.all" />
                    )}
                    isClearable
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={
              !values.states ||
              values.states.length === 0 ||
              (values.plants && values.plants.length === 0) ||
              (values.plantGroups && values.plantGroups.length === 0)
            }
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
}
